import axios from 'axios';
import backendUrl from '../components/assets/backend';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || backendUrl,
    withCredentials: true // Important for handling cookies
});

// Function to get CSRF cookie
export const getCsrfCookie = async () => {
    try {
        await api.get('/sanctum/csrf-cookie'); // This sets the CSRF cookie
    } catch (error) {
        console.error("Error getting CSRF cookie:", error);
        throw error; // Re-throw the error to handle it in your component
    }
};

// Axios request interceptor to attach the token to each request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('api_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;